module.exports = __webpack_public_path__ + "static/media/calendar.81bb0f1a.svg";